module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"paid_periods":"Paid periods","settings":"Settings","description":"Description"},"ua":{"paid_periods":"Платіжні періоди","settings":"Налаштування","description":"Опис"},"ru":{"paid_periods":"Платежные периоды","settings":"Настройки","description":"Описание"}}')
  delete Component.options._Ctor
}
